export default __webpack_public_path__ + "static/media/yellowSpotLogo.5ff28445.svg";